var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeployment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8889 19.7778C9.8889 21.0051 10.8838 22 12.1111 22C13.3384 22 14.3333 21.0051 14.3333 19.7778C14.3333 18.5505 13.3384 17.5555 12.1111 17.5555C10.8838 17.5555 9.8889 18.5505 9.8889 19.7778Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7778 19.7778C18.7778 21.0051 19.7727 22 21 22C22.2273 22 23.2222 21.0051 23.2222 19.7778C23.2222 18.5505 22.2273 17.5555 21 17.5555C19.7727 17.5555 18.7778 18.5505 18.7778 19.7778Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00001 19.7778C1.00001 21.0051 1.99493 22 3.22223 22C4.44953 22 5.44445 21.0051 5.44445 19.7778C5.44445 18.5505 4.44953 17.5555 3.22223 17.5555C1.99493 17.5555 1.00001 18.5505 1.00001 19.7778Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 7.55554C17.5335 7.55554 18.4669 7.55554 19.18 7.86695C19.8072 8.14088 20.3171 8.57796 20.6367 9.11557C21 9.72675 21 10.5268 21 12.127L21 14.2222M8.55556 7.55554C6.68871 7.55554 5.75529 7.55554 5.04225 7.86695C4.41505 8.14088 3.90511 8.57796 3.58553 9.11557C3.22222 9.72674 3.22222 10.5268 3.22222 12.127L3.22222 14.2222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8056 6.44444C15.8056 8.48483 14.1515 10.1389 12.1111 10.1389C10.0707 10.1389 8.41669 8.48483 8.41669 6.44444C8.41669 4.40406 10.0707 2.75 12.1111 2.75C14.1515 2.75 15.8056 4.40406 15.8056 6.44444Z",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1111 10.3334V14.2223",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.1111L3.22222 15.3333L5.44444 13.1111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88892 13.1111L12.1111 15.3333L14.3334 13.1111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7778 13.1111L21 15.3333L23.2222 13.1111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployment);
export default __webpack_public_path__ + "static/media/deployment.39b2b6999acbabecef5ccb8f9f05c9e9.svg";
export { ForwardRef as ReactComponent };